const getFeatures = (t) => ({
  concierge: t('constants.features.concierge'),
  elevator: t('constants.features.elevator'),
  children_area: t('constants.features.children_area'),
  landscape_decore: t('constants.features.landscape_decore'),
  sport_area: t('constants.features.sport_area'),

  is_children_room: t('constants.features.is_children_room'),
  is_conference_hall: t('constants.features.is_conference_hall'),
  is_wellness_building: t('constants.features.is_wellness_building'),
  is_panoramic_glazing: t('constants.features.is_panoramic_glazing'),
  is_beach: t('constants.features.is_beach'),
  is_walking_area: t('constants.features.is_walking_area'),
  is_operated_roof: t('constants.features.is_operated_roof'),
  is_garage: t('constants.features.is_garage'),
  is_acs_system: t('constants.features.is_acs_system'),
  is_landscape_park: t('constants.features.is_landscape_park'),
  is_management_company: t('constants.features.is_management_company'),

  spa: t('constants.features.spa'),
  fitness: t('constants.features.fitness'),
  pool: t('constants.features.pool'),
  kindergarten: t('constants.features.kindergarten'),
  tennis_court: t('constants.features.tennis_court'),
  recreation_zone: t('constants.features.recreation_zone'),
  fountain: t('constants.features.fountain'),
  garden: t('constants.features.garden'),
  helicopter_landing_area: t('constants.features.helicopter_landing_area'),
  commercial_property: t('constants.features.commercial_property'),
  cctv_surveillance: t('constants.features.cctv_surveillance'),
  kpp: t('constants.features.kpp'),
  restaurant: t('constants.features.restaurant'),
  billiards: t('constants.features.billiards'),
  sauna: t('constants.features.sauna'),
});

export default getFeatures;



// WEBPACK FOOTER //
// ./src/constants/Features.js